import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Typography from '@mui/joy/Typography';
import getIcon from 'utils/getIcon';

export default function BreadcrumbLink({ to, children, iconName, prefix="/"}: {to: string, children: React.ReactNode, iconName: string, prefix?: string }) {
    const Icon = getIcon(iconName);
    const location = useLocation();

    if (!location.pathname.startsWith(prefix)) {
        return null;
    }
    const kids = location.pathname.endsWith(to) ? children : <Link to={to}>{children}</Link>;
    return (
        <Typography
            startDecorator={<Icon />}
            level="title-lg">
            {kids}
    </Typography>
    );
}
